import React, { useEffect, useState } from 'react';
import { useClickOutside } from 'react-click-outside-hook';
import { Prompt } from 'react-router-dom';
import { HeaderText2TW } from 'tailwindComponents/HeaderTextTW/HeaderTextTW';
import { BodyTextTW } from 'tailwindComponents/bodyText/BodyTextTW';
import { Button, ModalWindow } from 'ui-toolkit';

export interface IOutsideClickHandlerProps {
  enabled: boolean;
  onCloseAndSave: () => void;
  onClose: () => void;
  children?: React.ReactNode;
}

export const OutsideClickHandler: React.FC<IOutsideClickHandlerProps> = ({
  children,
  enabled,
  onCloseAndSave,
  onClose,
}) => {
  const [ref, hasClickedOutside] = useClickOutside();
  const [showLeaveConfirm, setShowLeaveConfirm] = useState<boolean>(false);
  useEffect(() => {
    if (hasClickedOutside && enabled) {
      setShowLeaveConfirm(true);
    } else if (hasClickedOutside) {
      onClose();
    }
  }, [hasClickedOutside, setShowLeaveConfirm, enabled, onClose]);

  useEffect(() => {
    if (enabled) {
      window.addEventListener('beforeunload', alertUser);
      return () => {
        window.removeEventListener('beforeunload', alertUser);
      };
    }
    return () => {};
  }, [enabled]);
  const alertUser = (e: BeforeUnloadEvent) => {
    e.preventDefault();
    e.returnValue = '';
  };

  return (
    <div ref={ref}>
      {children}
      {enabled && <Prompt when message={'Changes you made may not be saved'} />}
      {showLeaveConfirm && (
        <ModalWindow mode={'transition'}>
          <div className={'grid justify-items-start gap-4'} data-test-id={'Fees-Details-Outside-Click-Handler-Wrapper'}>
            <HeaderText2TW>Unsaved Changes</HeaderText2TW>
            <BodyTextTW className={'text-left'}>
              Navigating away from this section will discard any changes you have made.
              <br />
              Do you want to save your changes?
            </BodyTextTW>
            <div className={'flex flex-row gap-4'}>
              <Button
                data-test-id={'Fees-Details-Outside-Click-Handler-Wrapper'}
                intent={'ghost'}
                type={'button'}
                onClick={() => setShowLeaveConfirm(false)}
              >
                Cancel - Continue Editing
              </Button>
              <Button
                data-test-id={'Fees-Details-Outside-Click-Handler-Wrapper'}
                intent={'danger'}
                type={'button'}
                onClick={() => {
                  setShowLeaveConfirm(false);
                  onClose();
                }}
              >
                No - Discard Changes
              </Button>
              <Button
                data-test-id={'Fees-Details-Outside-Click-Handler-Wrapper'}
                intent={'primary'}
                type={'submit'}
                onClick={() => {
                  onCloseAndSave();
                  setShowLeaveConfirm(false);
                }}
              >
                Yes - Save Changes
              </Button>
            </div>
          </div>
        </ModalWindow>
      )}
    </div>
  );
};
